import withLayout from 'apps/web-client/src/hoc/with-layout';
import React from 'react';

import ViewGroupController from './view-group.controller';

const ViewGroupScreen: React.FC = () => {
  return <ViewGroupController />;
};
export default withLayout(ViewGroupScreen);
